import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { updateChildSubTask, getTeammember, getUserProfile } from "../../Api/ApiUrlConst";
import { toast } from "react-toastify";

interface TeamMember {
  userId: string;
  userName: string;
  department: string; // ✅ correct field
}

// interface Props {
//   childTask: any;
//   onClose: (refresh?: boolean) => void;
// }

interface Props {
  childTask: any;
  onClose: (refresh?: boolean) => void;
  refreshChildTask?: () => void;
}

const MODELLING_STATUSES = [
  { value: "NotApplicable", label: "Not In Scope" },

  { value: "YetToStart", label: "Yet to Start" },
  { value: "InProgress", label: "In Progress" },
  { value: "OnHold", label: "On Hold" },
  { value: "ReadyForReview", label: "Ready for Review" },
  { value: "ReviewInProgress", label: "Review in Progress" },
  { value: "ChangesRequested", label: "Changes Requested" },
  { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
  { value: "CompletedAndApproved", label: "Completed & Approved" },
];

const DRAFTING_STATUSES = [
  { value: "NotApplicable", label: "Not In Scope" },
  { value: "YetToStart", label: "Yet to Start" },
  { value: "InProgress", label: "In Progress" },
  { value: "OnHold", label: "On Hold" },
  { value: "ReadyForReview", label: "Ready for Review" },
  { value: "ReviewInProgress", label: "Review in Progress" },
  { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
  { value: "ReadyToRelease", label: "Ready to Release" },
  { value: "CompletedAndReleased", label: "Completed " },
  { value: "NotApplicable1", label: "Released" },
];

const DEFAULT_STATUSES = [
  { value: "NotApplicable", label: "Not In Scope" },
  { value: "YetToStart", label: "Yet to Start" },
  { value: "InProgress", label: "In Progress" },
  { value: "OnHold", label: "On Hold" },
  { value: "Completed", label: "Completed" },

];






const EditChildSubTaskInline: React.FC<Props> = ({
  childTask,
  onClose,
  refreshChildTask,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);

  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([]);
  const [memberModalOpen, setMemberModalOpen] = useState(false);
  const [tempMemberIds, setTempMemberIds] = useState<string[]>([]);

  const loginUserDept = localStorage.getItem("department") || "";

  const [form, setForm] = useState({
    description: childTask.description,
    status: childTask.status,
    priority: childTask.priority,
    percentCompleted: childTask.percentCompleted,
    maxHours: childTask.maxHours,
    spentHours: childTask.spentHours,
    completionDate: childTask.completionDate ?? null,
    remarks: childTask.remarks ?? "",
    teamMemberIds: childTask.teamMemberIds ?? [],

  });

  // ✅ FETCH TEAM MEMBERS INTERNALLY
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingMembers(true);

        // keep same reference pattern
        await getUserProfile();

        const tmRes = await getTeammember();
        const membersData = tmRes.data?.$values || tmRes.data || [];

        setTeamMembers(
          membersData.map((tm: any) => ({
            userId: tm.userID,
            userName: tm.name,
          }))
        );
      } catch (err) {
        console.error("Error loading team members:", err);
      } finally {
        setLoadingMembers(false);
      }
    };

    fetchData();
  }, []);

  const handleSave = async () => {
    if (!form.teamMemberIds.length) {
      toast.error("Select at least one team member");
      return;
    }

    setLoading(true);
    try {
      await updateChildSubTask(childTask.id, {
        ...form,
        teamMemberIds: form.teamMemberIds,
      });


      // ✅ update local UI immediately
      const selectedNames = teamMembers
        .filter(m => form.teamMemberIds.includes(m.userId))
        .map(m => m.userName);

      childTask.teamMemberNames = selectedNames;
      childTask.teamMemberIds = form.teamMemberIds;

      toast.success("Child task updated");
      onClose(true);
      refreshChildTask?.();
    } catch {
      toast.error("Failed to update child task");
    } finally {
      setLoading(false);
    }
  };

  

  const getStatusOptions = () => {
    const desc = form.description?.toLowerCase() || "";

    if (desc.includes("modelling")) return MODELLING_STATUSES;
    if (desc.includes("drafting")) return DRAFTING_STATUSES;

    return DEFAULT_STATUSES;
  };

  useEffect(() => {
    const options = getStatusOptions();

    if (!options.some(o => o.value === form.status)) {
      setForm(prev => ({
        ...prev,
        status: options[0].value,
      }));
    }
  }, [form.description]);

  // ================= FETCH TEAM MEMBERS =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingMembers(true);

        const profileRes = await getUserProfile();

        // save login user department if not already saved
        if (profileRes.data?.department) {
          localStorage.setItem("department", profileRes.data.department);
        }

        const tmRes = await getTeammember();
        const membersData = tmRes.data?.$values || tmRes.data || [];

        setTeamMembers(
          membersData.map((tm: any) => ({
            userId: String(tm.userID),
            userName: tm.name,
            department: tm.department, // ✅ correct mapping
          }))
        );
      } catch (err) {
        console.error("Error loading team members:", err);
      } finally {
        setLoadingMembers(false);
      }
    };

    fetchData();
  }, []);

  const filteredMembers = teamMembers.filter(
    (m) =>
      m.department?.trim().toLowerCase() ===
      loginUserDept.trim().toLowerCase()
  );








  return (
    <>
      <tr className="table-warning" >
        <td style={{ marginLeft: "200px" }}>
          <Input
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
            style={{ width: "580px", marginLeft: "35px" }}
          />
        </td>

        <td style={{ width: '4%' }}><Input
          type="number"
          name="SpentHours"
          value={form.spentHours}
          onChange={(e) =>
            setForm({ ...form, spentHours: e.target.value })
          }
          disabled
        />
        </td>

        <td style={{ width: '5%' }}>
          <Input
            name="percentCompleted"
            type="number"
            min="0"
            max="100"
            value={form.percentCompleted}
            // onChange={(e) => {
            //   const newValue = Number(e.target.value) || 0;
            //   const currentValue = Number(form.percentCompleted) || 0;


            //   if (newValue < currentValue) return;

            //   setForm({ ...form, percentCompleted: newValue });
            // }}
            onChange={(e) => setForm({ ...form, percentCompleted: e.target.value })}

          />
        </td>


        <td>
          <Button
            size="sm"
            color="secondary"
            disabled={loadingMembers}
            onClick={() => {
              setTempMemberIds(form.teamMemberIds);
              setMemberModalOpen(true);
            }}
            style={{ width: "240px" }}
          >
            {loadingMembers
              ? "Loading..."
              : form.teamMemberIds.length
                ? `${form.teamMemberIds.length} Selected`
                : "Select Members"}
          </Button>
        </td>

        <td>
          <Input
            type="select"
            value={form.status}
            onChange={(e) =>
              setForm({ ...form, status: e.target.value })
            }
            style={{ width: "265px" }}
          >
            {getStatusOptions().map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Input>

        </td>



        <td>
          <Input
            type="select"
            value={form.priority}
            onChange={(e) =>
              setForm({ ...form, priority: e.target.value })
            }
            style={{ width: "250px" }}
          >
            <option value="Low">Medium</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </Input>
        </td>






        <td className="d-flex gap-2">
          <Button size="sm" color="primary" onClick={handleSave}>
            {loading ? <Spinner size="sm" /> : "Update"}
          </Button>
          <Button size="sm" color="secondary" onClick={() => onClose(false)}>
            Cancel
          </Button>
        </td>
      </tr>

      {/* ✅ MEMBER SELECTION MODAL */}
      <Modal isOpen={memberModalOpen} toggle={() => setMemberModalOpen(false)}>
        <ModalHeader toggle={() => setMemberModalOpen(false)}>
          Select Team Members
          {/* ({loginUserDept}) */}
        </ModalHeader>

        <ModalBody>
          {loadingMembers ? (
            <div className="text-center">
              <Spinner size="sm" />
            </div>
          ) : filteredMembers.length === 0 ? (
            <div className="text-center text-danger">
              No members found for your department
            </div>
          ) : (
            filteredMembers.map((m) => (
              <div key={m.userId} className="form-check mb-2">
                <Input
                  type="checkbox"
                  checked={tempMemberIds.includes(m.userId)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTempMemberIds((p) => [...p, m.userId]);
                    } else {
                      setTempMemberIds((p) =>
                        p.filter((id) => id !== m.userId)
                      );
                    }
                  }}
                />
                <label className="ms-2">
                  {m.userName}
                </label>
              </div>
            ))
          )}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button
              size="sm"
              color="primary"
              onClick={() => {
                setForm((p) => ({
                  ...p,
                  teamMemberIds: tempMemberIds,
                }));
                setMemberModalOpen(false);
              }}
            >
              Save
            </Button>

            <Button
              size="sm"
              color="secondary"
              onClick={() => setMemberModalOpen(false)}
            >
              Cancel
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default EditChildSubTaskInline;
